module.exports = (s) => {
  return [
    {
      name: '游戏',
      value: 'game',
      format: ({ game = {}}) => {
        return game?.name || '-';
      },
    },
    {
      name: '素材名称',
      format: ({ material }) => {
        return material.name;
      },
    },
    {
      name: '广告商',
      value: 'advertiser',
      format: ({ advertiser }) => {
        return s.channel_interface_map[advertiser];
      },
    },
    {
      name: '账号ID',
      value: 'advertiser_id',
    },
    {
      name: '消耗',
      value: 'cost',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '激活数',
      value: 'active',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '激活成本',
      value: 'active_cost',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '注册数',
      value: 'register',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '注册成本',
      value: 'register_cost',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '付费数',
      value: 'pay',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '付费成本',
      value: 'pay_cost',
      props: {
        sortable: 'custom',
      },
    },
    {
      name: '付费金额',
      props: {
        sortable: 'custom',
      },
      value: 'pay_amount',
    },
    {
      name: '曝光数',
      props: {
        sortable: 'custom',
      },
      value: 'impression',
    },
    {
      name: '点击量',
      props: {
        sortable: 'custom',
      },
      value: 'click',
    },
    {
      name: '点击率',
      props: {
        sortable: 'custom',
      },
      value: 'click_rate',
    },
    {
      name: '小游戏付费金额',
      props: {
        sortable: 'custom',
      },
      value: 'mini_game_paying_amount',
      format: function({ mini_game_paying_amount }) {
        return mini_game_paying_amount || '不支持';
      },
    },
    {
      name: '小游戏首次付费人数',
      props: {
        sortable: 'custom',
      },
      value: 'mini_game_first_paying_users',
      format: function({ mini_game_first_paying_users }) {
        return mini_game_first_paying_users || '不支持';
      },
    },
    {
      name: '小游戏付费成本',
      props: {
        sortable: 'custom',
      },
      value: 'mini_game_first_paying_cost',
      format: function({ mini_game_first_paying_cost }) {
        return mini_game_first_paying_cost || '不支持';
      },
    },
  ];
};

